module.exports = __webpack_public_path__ + "static/media/fly0272.89c3027b.webp";